export const howItWorks = {
  hero: {
    badge: "Guida completa",
    title: "Come funziona DONKEY TRAVEL?",
    subtitle:
      "Scopri passo dopo passo come scambiare la tua casa Airbnb con altri proprietari e viaggiare gratuitamente ovunque in Europa.",
    cta: "Inizia ora",
    learnMore: "Vedi i passaggi",
  },
  stats: {
    properties: "Alloggi disponibili",
    exchanges: "Scambi realizzati",
    countries: "Paesi coperti",
    satisfaction: "Soddisfazione",
  },
  steps: {
    badge: "Il processo",
    title: "Il tuo scambio in 7 passaggi",
    subtitle:
      "Un percorso semplice e sicuro, dall'iscrizione al tuo primo viaggio gratuito",
    step1: {
      title: "Crea il tuo profilo (15 min)",
      description:
        'È l\'unica tappa "lunga": 15 minuti per creare il tuo profilo. Un piccolo sforzo per anni di vacanze gratuite e felicità!',
      highlight1: "Abbonamento richiesto",
      highlight2: "Annuncio completo con foto",
      highlight3: "Verifica dell'identità",
      badge: "Iscrizione rapida",
    },
    step2: {
      title: "Esplora e trova la tua destinazione ideale",
      description:
        "Sfoglia la nostra mappa interattiva d'Europa e trova host verificati del club. Filtra per destinazione, date, tipo di alloggio e servizi per organizzare il tuo scambio.",
      highlight1: "Mappa interattiva Europa con filtri avanzati",
      highlight2: "Ricerca per destinazione, date e servizi",
      highlight3: "Membri host verificati nei paesi europei disponibili",
      badge: "Ricerca intelligente",
    },
    step3: {
      title: "Proponi uno scambio e negozia",
      description:
        "Contatta il proprietario che ti interessa e proponi uno scambio. Negozia le date e la durata in uno spirito conviviale. 10 notti contro 5? Tutto è possibile!",
      highlight1: "Messaggistica integrata e sicura",
      highlight2: "Negoziazione flessibile delle durate",
      highlight3: "Profili verificati e recensioni consultabili",
      badge: "Negoziazione facile",
    },
    step4: {
      title: "Conferma le date e sincronizza i calendari",
      description:
        "Una volta trovato l'accordo, conferma le date di scambio. I tuoi calendari Airbnb e DONKEY TRAVEL si sincronizzano automaticamente per evitare conflitti di prenotazione.",
      highlight1: "Sincronizzazione automatica con Airbnb",
      highlight2: "Promemoria e notifiche prima del soggiorno",
      highlight3: "Modifica flessibile fino a 48h prima",
      badge: "Calendario sincronizzato",
    },
    step5: {
      title: "Contratto amichevole PDF inviato ai due host",
      description:
        "DONKEY TRAVEL redige un contratto amichevole in PDF e lo invia ai due host. Una volta terminato il primo scambio, hai 24 mesi per effettuare lo scambio di ritorno.",
      highlight1: "Contratto amichevole PDF inviato automaticamente ai 2 host",
      highlight2: "Documento riepilogativo di date e condizioni convalidate",
      highlight3:
        "24 mesi per realizzare lo scambio di ritorno dopo il primo soggiorno",
      badge: "Contratto PDF",
    },
    step6: {
      title: "Viaggia e goditi il tuo soggiorno gratuito!",
      description:
        "È il grande giorno! accomodati nella tua casa di scambio e goditi vacanze autentiche. Dopo il soggiorno, lascia una recensione per aiutare la comunità.",
      highlight1: "Accoglienza personalizzata dal proprietario",
      highlight2: "Guida locale con raccomandazioni",
      highlight3: "Sistema di recensioni dopo ogni scambio",
      badge: "Buon viaggio!",
    },
  },
  advantages: {
    badge: "I nostri vantaggi",
    title: "Perché scegliere DONKEY TRAVEL?",
    subtitle:
      "Una piattaforma pensata per i proprietari Airbnb che vogliono viaggiare diversamente",
    items: {
      security: {
        title: "Sicurezza massima",
        description:
          "Tutti i membri sono proprietari Airbnb verificati. Identità controllata, recensioni consultabili e assicurazione inclusa per ogni scambio.",
      },
      savings: {
        title: "Risparmi considerevoli",
        description:
          "Viaggia gratuitamente scambiando le tue notti. Risparmia in media 2.500€ all'anno sulle spese di alloggio.",
      },
      community: {
        title: "Comunità di fiducia",
        description:
          "Unisciti alla nostra comunità di viaggiatori. Condividi le tue esperienze, scambia consigli e crea legami duraturi.",
      },
      support: {
        title: "Supporto 7/7",
        description:
          "Il nostro team è disponibile in qualsiasi momento per accompagnarti. Chat in diretta, email e telefono per un'assistenza completa.",
      },
      quality: {
        title: "Alloggi di qualità",
        description:
          "Ogni alloggio è verificato e valutato dalla comunità. Standard elevati per garantire soggiorni eccezionali.",
      },
      global: {
        title: "Rete europea",
        description:
          "Accedi a host verificati nei paesi europei disponibili del club e organizza i tuoi scambi in fiducia.",
      },
    },
  },
  testimonials: {
    badge: "Testimonianze",
    title: "Hanno provato e approvato",
    subtitle: "Scopri le esperienze dei nostri membri in tutto il mondo",
    banner: {
      title: "Anche tu puoi viaggiare più spesso!",
      subtitle:
        "Unisciti alla community di host che viaggiano in modo diverso.",
    },
    items: {
      sophie: {
        name: "Sophie",
        location: "Parigi, Francia",
        badge: "2 scambi",
        text: "Grazie a DONKEY TRAVEL, ho visitato Barcellona, Roma e Amsterdam senza pagare alloggio. La community è reattiva e le discussioni di scambio sono semplici.",
      },
      marc: {
        name: "Marc",
        location: "Marsiglia, Francia",
        badge: "1 scambio",
        text: "Il processo è incredibilmente semplice. In 3 giorni, ho trovato uno scambio perfetto per le mie vacanze estive. La sincronizzazione con Airbnb è un enorme vantaggio.",
      },
      leaTom: {
        name: "Léa & Tom",
        location: "Lione, Francia",
        badge: "Nuovi membri",
        text: "Ciò che ci ha colpito di più è la community. I proprietari sono premurosi e gli scambi avvengono in un'atmosfera di totale fiducia.",
      },
      dupont: {
        name: "Famiglia Dupont",
        location: "Bordeaux, Francia",
        badge: "3 scambi",
        text: "Perfetto per viaggiare in famiglia durante le vacanze scolastiche!",
      },
      alex: {
        name: "Alex",
        location: "Berlino, Germania",
        badge: "5 scambi",
        text: "Una rete incredibile per lo smart working. Scambio il mio loft berlinese con appartamenti soleggiati.",
      },
      marie: {
        name: "Marie",
        location: "Tolosa, Francia",
        badge: "4 scambi",
        text: "Nessun vincolo finanziario! Parto per un weekend ogni mese.",
      },
      testimonial2: {
        text: "Il processo è così semplice. In 3 giorni, avevo trovato uno scambio perfetto per le mie vacanze estive. La sincronizzazione con Airbnb è un vero vantaggio.",
      },
      testimonial3: {
        text: "Ciò che mi ha sedotta di più è la comunità. I proprietari sono accoglienti e gli scambi avvengono in un'atmosfera di totale fiducia.",
      },
    },
  },
  faq: {
    title: "Domande frequenti",
    subtitle: "Tutto quello che devi sapere prima di iniziare",
    items: {
      q1: {
        question: "L'iscrizione è a pagamento?",
        answer:
          "Sì. L'accesso a DONKEY TRAVEL avviene tramite abbonamento annuale. Offerta lancio 2026: 25EUR/anno invece di 50EUR/anno.",
      },
      q2: {
        question: "Devo essere proprietario Airbnb per iscrivermi?",
        answer:
          "Sì, DONKEY TRAVEL è riservato ai proprietari che hanno un alloggio su Airbnb. Questo garantisce la qualità e l'affidabilità di ogni membro della comunità.",
      },
      q3: {
        question: "Come sono protetti gli scambi?",
        answer:
          "Ogni scambio è coperto dalla nostra assicurazione partner. Inoltre, tutti i membri sono verificati (identità, alloggio, recensioni Airbnb) e il nostro team di supporto è disponibile 7/7.",
      },
      q4: {
        question: "Posso scambiare con qualcuno in un altro paese?",
        answer:
          "Sì. Puoi scambiare con altri host verificati nei paesi europei disponibili secondo il tuo abbonamento.",
      },
      q5: {
        question: "Cosa succede se lo scambio viene cancellato?",
        answer:
          "La nostra politica di cancellazione protegge entrambe le parti. In caso di cancellazione, ti aiutiamo a trovare un'alternativa.",
      },
      q6: {
        question: "Quanto dura uno scambio in media?",
        answer:
          "La durata è totalmente flessibile e si negozia tra i due proprietari. In media, gli scambi durano tra 5 e 14 notti, ma alcuni fanno scambi di un weekend o di un mese intero.",
      },
    },
  },
  cta: {
    title: "Pronto a viaggiare gratuitamente?",
    subtitle: "Unisciti alla nostra comunità di viaggiatori.",
    explore: "Esplora le destinazioni",
    members: "Membri attivi",
    countries: "Paesi disponibili",
    satisfaction: "Di soddisfazione",
  },
};
